module.exports = __webpack_public_path__ + "media/images/flags/4x3/mrt-22da2dfa6157b184976557b38a07d839.svg";